import React from "react";
import { Checkbox, Badge, Modal } from "antd";
import Cookies from "js-cookie";
import { useState } from "react";
import { DatabaseFilled } from '@ant-design/icons';
export default function LiveToggle() {

    
    const [isLive, setIsLive] = useState(Cookies.get("l") || "false");

    // Don't show toggle in production
    let mode = process.env.REACT_APP_API || 'inherit';
    if (mode === "live" || mode === "staging") {
        return (<></>);
    }

    const showModal = () => {

        Modal.info({
            title: "Switch data source",
            width: 300,
            content: (
                <>
                    <div className="shim" /><div className="shim" />
                    <Checkbox defaultChecked={(isLive === "true")} onChange={(e) => Cookies.set("l", (e.target.checked) ? "true" : "false")}>Use live data?</Checkbox>
                </>
            ),
            onOk : () => {
                window.location.reload(); 
            }
        })

    }

    let _style = {
        boxShadow: "0px 2px 3px 1px #aaa",
        width: "25px",
        position: "fixed",
        zIndex: "1000",
        top: "-1px",
        left: "20px",
        backgroundColor: "#fff",
        borderBottomLeftRadius: "3px",
        borderBottomRightRadius: "3px",
        cursor: "pointer",
        margin: "0 auto"
    }


    return (
        <div onClick={() => showModal()} style={_style} >
            <div style={{"height" : "2px"}} className="shim" />
            <Badge offset={[9, 0]} status={(isLive === "true") ? "success" : "default"} />
            <div style={{"height" : "2px"}} className="shim" />
        </div>
    )
}